export default "__VITE_ASSET__HFXW9AS9__"